import { z } from "zod";

import { BRAND_MARKUP } from "../../constants";
import { defineModel } from "../types";

const COST_PER_CHAR_MICRODOLLARS = 0.0001 * 1_000_000;

const minimaxSpeech28HdParams = z
  .object({
    voiceId: z.string().default(""),
    prompt: z.string().default(""),
    languageBoost: z.string().optional(),
  })
  .strip();

export const minimaxSpeech28Hd = defineModel({
  key: "minimax-speech-2-8-hd",
  stepType: "tts",
  spec: {
    label: "Wonda Speech HD",
    description:
      "HD text-to-speech that supports voices cloned through `wonda voice create`.",
    icon: "minimax-icon.svg",
    tags: ["minimax", "fal"],
    features: { prompts: true } as const,
    options: {
      voice: { items: [] },
    },
    params: minimaxSpeech28HdParams,
  },
  providers: [
    {
      provider: "fal",
      modelId: "fal-ai/minimax/speech-2.8-hd",
      estimateCost(params) {
        const charCount = (params.prompt ?? "").length;
        return Math.round(
          charCount * COST_PER_CHAR_MICRODOLLARS * (1 + BRAND_MARKUP),
        );
      },
      toPayload(params) {
        return {
          prompt: params.prompt ?? "",
          voiceId: params.voiceId ?? "",
          languageBoost: params.languageBoost,
        };
      },
    },
  ],
});
